/** Pure screen MIME table and selection with an injected probe; MP4 leads so Safari 15+ picks h264/aac and others fall to WebM. */
import type { AudioMimeEnv } from "./audio-mime";

/** Priority-ordered screen-capture MIME candidates. */
export const SCREEN_MIME_CANDIDATES = [
  "video/mp4;codecs=h264,aac",
  "video/mp4",
  "video/webm;codecs=vp9,opus",
  "video/webm;codecs=vp8,opus",
  "video/webm",
] as const;

/** Browser hints for screen codec preference (same shape as audio). */
export type ScreenMimeEnv = AudioMimeEnv;

/** Resolve the best screen MIME: the first supported candidate, or an empty string (also without `MediaRecorder`). */
export function negotiateScreenMime(env: ScreenMimeEnv): string {
  const probe = env.isTypeSupported;
  if (!probe) return "";
  for (const candidate of SCREEN_MIME_CANDIDATES) {
    if (probe(candidate)) return candidate;
  }
  return "";
}
